"use client";

import {
  Dialog,
  DialogPortal,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Switch,
  Button,
} from "@/ui";
import { colors, spacing, textStyles } from "@/ui/tokens";
import styles from "./SettingsDialog.module.css";

export interface SettingsDialogProps {
  open: boolean;
  onClose: () => void;
  debugMode: boolean;
  onDebugToggle: (enabled: boolean) => void;
}

export function SettingsDialog({ open, onClose, debugMode, onDebugToggle }: SettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogPortal>
        <DialogBackdrop className={styles.backdrop} />
        <DialogContent size="sm" className={styles.content}>
          <DialogHeader>
            <DialogTitle>SOLA Settings</DialogTitle>
          </DialogHeader>

          <div style={{ padding: spacing[4], display: 'flex', flexDirection: 'column', gap: spacing[4] }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Switch
                checked={debugMode}
                onChange={onDebugToggle}
                label="Debug Mode"
              />
            </div>
            <p style={{ ...textStyles.body2, color: colors.text.muted, margin: 0 }}>
              Shows how SOLA works through each request: the model&apos;s reasoning,
              a full card for every tool it uses, and a toolbar to copy the chat or
              send a random test prompt. Off, SOLA shows its answers, with finished
              steps collapsed into one line.
            </p>
          </div>

          <DialogFooter>
            <Button variant="tertiary" onClick={onClose}>Close</Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
